import { Link } from 'react-router-dom';
import { PageTitle } from '../PageTitle';

export function LegalPage({
  title,
  documentTitle,
  updated,
  children,
}: {
  title: string;
  documentTitle: string;
  updated: string;
  children: React.ReactNode;
}) {
  return (
    <div className="bg-paper text-ink">
      <PageTitle>{documentTitle}</PageTitle>
      <article className="mx-auto max-w-3xl px-5 py-14 md:px-8 md:py-20">
        <p className="overline">Dala</p>
        <h1 className="mt-3 text-4xl leading-tight md:text-5xl">{title}</h1>
        <p className="mt-3 text-[13px] font-semibold text-ink/45">
          Last updated {updated}
        </p>
        <div className="legal mt-10 space-y-8 text-[15px] font-medium leading-[1.7] text-ink/75">
          {children}
        </div>
        <p className="mt-12 text-sm font-bold">
          <Link to="/" className="text-terracotta hover:underline">
            ← Back to dala
          </Link>
        </p>
      </article>
    </div>
  );
}
